import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@chakra-ui/react';
import { UsabilityRouteMarks } from './tools/usability/UsabilityRouteMarks'
import { HomePage } from './pages/HomePage'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { ContactSearchPage } from './pages/ContactSearchPage'
import { ContactCreatePage } from './pages/ContactCreatePage'
import { ContactDetailPage } from './pages/ContactDetailPage'
import { ListsPage } from './pages/ListsPage'
import { ListOverviewPage } from './pages/ListOverviewPage'
import { GuidedListWizardPage } from './pages/GuidedListWizardPage'
import { ListBuilderPage } from './pages/ListBuilderPage'
import { SearchBuilderPage } from './pages/SearchBuilderPage'
import { CanvassingDashboardPage } from './pages/CanvassingDashboardPage'
import { CanvassingScriptsPage } from './pages/CanvassingScriptsPage'
import { ScriptBuilderPage } from './pages/ScriptBuilderPage'
import { CanvassingSurveysPage } from './pages/CanvassingSurveysPage'
import { CanvassingTagsPage } from './pages/CanvassingTagsPage'
import { CanvassingTurfCutterPage } from './pages/CanvassingTurfCutterPage'
import { TurfCutterPage } from './pages/TurfCutterPage'
import { TurfDetailPage } from './pages/TurfDetailPage'
import { TurfMapOverviewPage } from './pages/TurfMapOverviewPage'
import { CampaignListPage } from './pages/CampaignListPage'
import { CampaignDashboardPage } from './pages/CampaignDashboardPage'
import { CampaignCanvassersPage } from './pages/campaign/CampaignCanvassersPage'
import { CampaignSignalsPage } from './pages/campaign/CampaignSignalsPage'
import { DashboardLayout } from './components/layout'
import { RequireAuth } from './components/auth/RequireAuth'
import { AdminGuard } from './components/admin/AdminGuard'
import { OrganizerGuard } from './components/auth/OrganizerGuard'
import { EmailComposePage } from './pages/EmailComposePage'
import { EmailListPage } from './pages/EmailListPage'
import { EmailDetailPage } from './pages/EmailDetailPage'
import { EmailTemplatesPage } from './pages/EmailTemplatesPage'
import { EmailSuppressionsPage } from './pages/EmailSuppressionsPage'
import { AdminUsersPage } from './pages/AdminUsersPage'
import { AdminGrantsPage } from './pages/AdminGrantsPage'
import { AdminInvitesPage } from './pages/AdminInvitesPage'
import { AdminCommitteesPage } from './pages/AdminCommitteesPage'
import { CommitteeFormPage } from './pages/CommitteeFormPage'
import { ScopeConfigPage } from './pages/admin/ScopeConfigPage'
import { AnalyticsMapPage } from './pages/AnalyticsMapPage'
import { DistrictProfilePage } from './pages/DistrictProfilePage'
import { ScenarioWorkspacePage } from './pages/ScenarioWorkspacePage'
import { BusinessListPage } from './pages/BusinessListPage'
import { WorksiteDetailPage } from './pages/WorksiteDetailPage'
import { BusinessDetailPage } from './pages/BusinessDetailPage'
import { UnionListPage } from './pages/UnionListPage'
import { UnionDetailPage } from './pages/UnionDetailPage'
import { CanvasserLayout } from './components/layout/CanvasserLayout'
import { RequireGrant } from './components/canvasser/RequireGrant'
import { RedeemPage } from './pages/canvasser/RedeemPage'
import { JoinPage } from './pages/canvasser/JoinPage'
import { CanvasserSignedOutPage } from './pages/canvasser/CanvasserSignedOutPage'
import { CanvasserProfilePage } from './pages/canvasser/CanvasserProfilePage'
import { CampaignHomePage } from './pages/canvasser/CampaignHomePage'
import { DoorPage } from './pages/canvasser/DoorPage'
import { ActionRouteRoute } from './pages/canvasser/ActionRouteScreen'
import { CallBatchRoute } from './pages/canvasser/CallBatchScreen'
import { TodayPage } from './pages/canvasser/TodayPage'
import { ModuleComingSoonPage } from './pages/ModuleComingSoonPage'
import { LobbyDayListPage } from './pages/LobbyDayListPage'
import { LobbyDayEventPage } from './pages/LobbyDayEventPage'
import { LobbyPrintPacketsPage } from './pages/LobbyPrintPacketsPage'
import { LegislatorsPage } from './pages/LegislatorsPage'
import { LobbyMySchedulePage } from './pages/lobby/LobbyMySchedulePage'
import { LobbyPacketPage } from './pages/lobby/LobbyPacketPage'
import { LobbyAttendeeSettingsPage } from './pages/lobby/LobbyAttendeeSettingsPage'
import { FindMyLinkPage } from './pages/lobby/FindMyLinkPage'
import { AcceptInvitePage } from './pages/AcceptInvitePage'
import { ReportCatalogPage } from './pages/ReportCatalogPage'
import { ReportRunnerPage } from './pages/ReportRunnerPage'
import { ReportRunPage } from './pages/ReportRunPage'
import { ReportRunsPage } from './pages/ReportRunsPage'
import { SettingsPage } from './pages/SettingsPage'

export function App() {
  return (
    <BrowserRouter>
      {import.meta.env.DEV &&
        new URLSearchParams(window.location.search).has('usability') && <UsabilityRouteMarks />}
      <Box minH="100vh">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Authenticated routes — RequireAuth bounces unauthenticated users to /login */}
          <Route element={<RequireAuth />}>
          {/* Dashboard routes with layout */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="contacts/search" element={<ContactSearchPage />} />
            <Route path="contacts/new" element={<ContactCreatePage />} />
            <Route path="contacts/:id" element={<ContactDetailPage />} />
            {/* List Builder */}
            <Route path="lists" element={<ListsPage />} />
            <Route path="lists/guided" element={<GuidedListWizardPage />} />
            <Route path="lists/new" element={<ListBuilderPage />} />
            <Route path="lists/:id/edit" element={<ListBuilderPage />} />
            <Route path="lists/:id" element={<ListOverviewPage />} />
            {/* Worksites & Businesses */}
            <Route path="worksites" element={<BusinessListPage />} />
            <Route path="worksites/:id" element={<WorksiteDetailPage />} />
            <Route path="businesses/:id" element={<BusinessDetailPage />} />
            {/* Unions */}
            <Route path="unions" element={<UnionListPage />} />
            <Route path="unions/:id" element={<UnionDetailPage />} />
            {/* Analytics Map */}
            <Route path="analytics-map" element={<AnalyticsMapPage />} />
            <Route path="analytics/profile/:geoUnitId" element={<DistrictProfilePage />} />
            <Route path="analytics/scenarios" element={<ScenarioWorkspacePage />} />
            {/* Search Template Builder */}
            <Route path="searches/new" element={<SearchBuilderPage />} />
            <Route path="searches/:id/edit" element={<SearchBuilderPage />} />
            {/* Turf routes (accessed from campaign context) */}
            <Route path="turfs/:id" element={<TurfDetailPage />} />
            <Route path="turf-maps/new" element={<TurfCutterPage />} />
            <Route path="turf-maps/:id" element={<TurfMapOverviewPage />} />
            {/* Campaign routes */}
            <Route path="campaigns" element={<CampaignListPage />} />
            <Route path="campaigns/:id" element={<CampaignDashboardPage />} />
            <Route path="campaigns/:id/canvassers" element={<CampaignCanvassersPage />} />
            <Route path="campaigns/:id/signals" element={<CampaignSignalsPage />} />
            {/* Canvassing routes */}
            <Route path="canvassing" element={<CanvassingDashboardPage />} />
            <Route path="canvassing/scripts" element={<CanvassingScriptsPage />} />
            <Route path="canvassing/scripts/new" element={<ScriptBuilderPage />} />
            <Route path="canvassing/scripts/:id/edit" element={<ScriptBuilderPage />} />
            <Route path="canvassing/surveys" element={<CanvassingSurveysPage />} />
            <Route path="canvassing/tags" element={<CanvassingTagsPage />} />
            <Route path="canvassing/turf-cutter" element={<CanvassingTurfCutterPage />} />
            {/* Admin routes */}
            <Route path="admin/users" element={<AdminGuard><AdminUsersPage /></AdminGuard>} />
            <Route path="admin/grants" element={<AdminGuard><AdminGrantsPage /></AdminGuard>} />
            <Route path="admin/invites" element={<AdminGuard><AdminInvitesPage /></AdminGuard>} />
            <Route path="admin/committees" element={<AdminGuard><AdminCommitteesPage /></AdminGuard>} />
            <Route path="admin/committees/new" element={<AdminGuard><CommitteeFormPage /></AdminGuard>} />
            <Route path="admin/committees/:id/edit" element={<AdminGuard><CommitteeFormPage /></AdminGuard>} />
            {/* SuperAdmin-only: AdminGuard only enforces the generic Admin tier, so the page
                itself gates its content on SuperAdmin (see ScopeConfigPage.tsx comment) --
                the real enforcement is the backend's [Authorize] on all five endpoints. */}
            <Route path="admin/scope-config" element={<AdminGuard><ScopeConfigPage /></AdminGuard>} />
            {/* Lobby Day routes */}
            <Route path="lobby-day" element={<LobbyDayListPage />} />
            <Route path="lobby-day/events/:id" element={<LobbyDayEventPage />} />
            <Route path="lobby-day/events/:id/print-packets" element={<LobbyPrintPacketsPage />} />
            <Route path="lobby-day/legislators" element={<LegislatorsPage />} />
            {/* Reporting routes — reports/runs and reports/runs/:runId must stay registered
                before reports/:key, or /dashboard/reports/runs(/anything) would match the
                parameterised report route and try to open a report named "runs". */}
            <Route path="reports" element={<ReportCatalogPage />} />
            <Route path="reports/runs" element={<ReportRunsPage />} />
            <Route path="reports/runs/:runId" element={<ReportRunPage />} />
            <Route path="reports/:key" element={<ReportRunnerPage />} />
            {/* L4 Communications — email compose/sent-list/detail (Organizer/Admin; UX-only,
                backend enforces). "communications/email/new" must stay registered before
                "communications/email/:id", or /communications/email/new would match the
                parameterised detail route and try to open a message named "new". */}
            <Route path="communications/email/new" element={<OrganizerGuard><EmailComposePage /></OrganizerGuard>} />
            <Route path="communications/email/:id" element={<OrganizerGuard><EmailDetailPage /></OrganizerGuard>} />
            <Route path="communications/email" element={<OrganizerGuard><EmailListPage /></OrganizerGuard>} />
            <Route path="communications/templates" element={<OrganizerGuard><EmailTemplatesPage /></OrganizerGuard>} />
            {/* Coming-soon module stubs */}
            <Route path="communications" element={<ModuleComingSoonPage moduleId="communications" />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="settings/communications/suppressions" element={<OrganizerGuard><EmailSuppressionsPage /></OrganizerGuard>} />
          </Route>
          </Route>

          {/* Canvasser grant-session entry — open (no guard): a fresh device
              redeems an invite token, self-enrolls with a shared campaign code
              (/join, /join/:code — the code pre-fills for a QR/link arrival), or
              lands on the signed-out screen when its grant session expired/was revoked. */}
          <Route path="/canvasser/redeem" element={<RedeemPage />} />
          <Route path="/join" element={<JoinPage />} />
          <Route path="/join/:code" element={<JoinPage />} />
          <Route path="/canvasser/redeem-needed" element={<CanvasserSignedOutPage />} />

          {/* Canvasser app routes (mobile-first layout) — grant-gated, NOT the
              organizer/admin JWT session above. RequireGrant is UX-only; every
              server endpoint underneath is independently GrantOnly. */}
          <Route element={<RequireGrant />}>
            <Route path="/canvasser" element={<CanvasserLayout />}>
              <Route index element={<CampaignHomePage />} />
              {/* [Phase 1] The walk list lives at the campaign home now; keep bookmarks working. */}
              <Route path="walk-list" element={<Navigate to="/canvasser" replace />} />
              <Route path="door/:stopKey" element={<DoorPage />} />
              {/* [CF-1 P3] Action-route deep link (?turfId=); the home normally renders it inline. */}
              <Route path="action-route" element={<ActionRouteRoute />} />
              {/* [CF-1 P4] Call-batch deep link (?callBatchId=); the home normally renders it inline. */}
              <Route path="call-batch" element={<CallBatchRoute />} />
              {/* [CF-1 P3] The Today picker (opening it clears the remembered choice). */}
              <Route path="today" element={<TodayPage />} />
              <Route path="session/:contactId" element={<Navigate to="/canvasser" replace />} />
              <Route path="map" element={<Navigate to="/canvasser?view=map" replace />} />
              <Route path="profile" element={<CanvasserProfilePage />} />
            </Route>
          </Route>

          {/* Public attendee lobby-day routes — token-gated, no login (design decision D1) */}
          <Route path="/lobby/:token" element={<LobbyMySchedulePage />} />
          <Route path="/lobby/:token/meetings/:meetingId" element={<LobbyPacketPage />} />
          <Route path="/lobby/:token/settings" element={<LobbyAttendeeSettingsPage />} />

          {/* GI-10 public attendee link self-resend — no login, no layout, outside every guard */}
          <Route path="/find-my-link" element={<FindMyLinkPage />} />

          {/* Public accept-invite page — token-gated, no login (NEW-06) */}
          <Route path="/accept-invite/:token" element={<AcceptInvitePage />} />

          {/* Redirect old paths */}
          <Route path="/contacts/search" element={<Navigate to="/dashboard/contacts/search" replace />} />
          <Route path="/dashboard/admin/canvasser-grants" element={<Navigate to="/dashboard/admin/grants" replace />} />
        </Routes>
      </Box>
    </BrowserRouter>
  )
}
